import React, { useState, useRef } from 'react';
import './FamiliaCard.css';
import { useNavigate } from 'react-router-dom';
import './FamiliaCard.css';
import { DEFAULT_THUMB_URL } from '../utils/storage';

const DEFAULT_THUMB = DEFAULT_THUMB_URL;

const FamiliaCard = ({ familia, subfamiliaCount = 0, validThumbnails = [], currentThumbnail, onSelectFamilia }) => {
  const [thumbIndex, setThumbIndex] = useState(0);
  const intervalRef = useRef(null);

  const LOOP_INTERVAL = 3000;

  const handleCardClick = () => {
    if (typeof onSelectFamilia === 'function') {
      onSelectFamilia(familia.id);
    }
  };

  const startLoop = () => {
    if (validThumbnails.length > 1 && !intervalRef.current) {
      intervalRef.current = setInterval(() => {
        setThumbIndex(idx => (idx + 1) % validThumbnails.length);
      }, LOOP_INTERVAL);
    }
  };

  const stopLoop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setThumbIndex(0);
    }
  };

  const thumbSrc = validThumbnails.length > 0
    ? validThumbnails[thumbIndex]
    : (currentThumbnail || DEFAULT_THUMB);

  return (
    <div className="familia-card" onClick={handleCardClick} onMouseEnter={startLoop} onMouseLeave={stopLoop}>
      <div className="familia-card-image" style={{ position: 'relative', width: '100%', height: '100%' }}>
        <img
          src={thumbSrc}
          alt={familia.nombre}
          loading="lazy"
          decoding="async"
          className="familia-card-thumbnail"
          style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }}
          onError={e => { e.target.src = DEFAULT_THUMB; }}
        />
      </div>
      <div className="familia-card-content">
        <h3 className="familia-card-title">{familia.nombre}</h3>
        <p className="familia-card-count">
          {subfamiliaCount} {subfamiliaCount === 1 ? 'producto' : 'productos'}
        </p>
        <div className="familia-card-cta">
          Ver productos →
        </div>
      </div>
    </div>
  );
}

export default FamiliaCard;